(function () {
  'use strict';

  /* Skip on touch/mobile — magnetic effect is mouse-only */
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Selectors that get the magnetic treatment — every CTA on the site */
  var SELECTORS = [
    /* NightSteel custom CTAs — full list */
    '.ns-btn',
    '.ns-contact-btn',
    '.ns-contact__submit',
    '.ns-contact__cta',
    '.ns-counter__cta',
    '.ns-day__cta',
    '.ns-footer__button',
    '.ns-footer__cta',
    '.ns-glossary__cta',
    '.ns-mp__button',
    '.ns-as__button',
    '.ns-std__button',
    '.ns-hero__cta',
    '.ns-inside-volt-final__button',
    '.ns-real-cost__cta',
    '.ns-sticky-cta__btn',
    '.ns-volt-final-purchase__button',
    '.ns-volt-founder-excerpt__button',
    '.ns-volt-hero__button',
    '.ns-wl__cta-btn',
    '.ns-wl__sticky-btn',
    '.ns-wl__submit-btn',
    '.wl-form__btn',
    '.ns-pw__submit',
    /* Base Impact theme buttons */
    'a.button',
    'button.button',
    '.button--primary',
    '.button--secondary',
    /* Shopify buy buttons */
    '.shopify-payment-button__button',
    /* Nav CTA button */
    '.header__link-list .contents > li:last-child > a',
    /* Data attribute override */
    '[data-magnetic]'
  ].join(', ');

  /* How far the button drifts — outer shell vs inner content */
  var STRENGTH_OUTER = 0.32;
  var STRENGTH_INNER = 0.14;

  function initMagnetic(el) {
    if (el.dataset.magneticInit) return;
    /* Skip icon-sized buttons (close, dismiss, arrow-only, etc.) */
    if (el.offsetWidth < 72) return;
    el.dataset.magneticInit = 'true';

    /* Wrap inner content so it can move independently */
    var inner = el.querySelector('.ns-magnetic__inner');
    if (!inner) {
      inner = document.createElement('span');
      inner.className = 'ns-magnetic__inner';
      inner.style.cssText = 'display:contents;';
      while (el.firstChild) inner.appendChild(el.firstChild);
      el.appendChild(inner);
    }

    var ticking = false;
    var lastEvent = null;

    el.addEventListener('mousemove', function (e) {
      lastEvent = e;
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        var rect = el.getBoundingClientRect();
        var cx   = rect.left + rect.width  / 2;
        var cy   = rect.top  + rect.height / 2;
        var dx   = lastEvent.clientX - cx;
        var dy   = lastEvent.clientY - cy;

        /* Whole pixels only. A fractional translate on a composited,
           bordered button anti-aliases its edge into a visible hairline
           while hovering; snapping keeps every edge on the pixel grid. */
        el.style.transform    = 'translate(' + Math.round(dx * STRENGTH_OUTER) + 'px,' + Math.round(dy * STRENGTH_OUTER) + 'px)';
        inner.style.transform = 'translate(' + Math.round(dx * STRENGTH_INNER) + 'px,' + Math.round(dy * STRENGTH_INNER) + 'px)';
        ticking = false;
      });
    });

    el.addEventListener('mouseleave', function () {
      el.style.transform    = '';
      inner.style.transform = '';
    });
  }

  function applyAll() {
    document.querySelectorAll(SELECTORS).forEach(initMagnetic);
  }

  /* CSS: transition for the spring-back */
  var style = document.createElement('style');
  style.textContent = [
    SELECTORS + '{',
    '  transition: transform 0.55s cubic-bezier(0.23,1,0.32,1);',
    '  will-change: transform;',
    '}',
    '.ns-magnetic__inner{',
    '  transition: transform 0.45s cubic-bezier(0.23,1,0.32,1);',
    '  display: inline-flex; align-items: center; gap: inherit;',
    '}'
  ].join('');
  document.head.appendChild(style);

  /* Init on ready + re-init after Shopify section loads */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }

  document.addEventListener('shopify:section:load', applyAll);
})();
